import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import {
  INITIAL_CASE_AGENT_HARNESS,
  INITIAL_CASE_INFO,
} from "../../../../../features/Cases/constants";
import {
  addNewOutputAttributesFieldAction,
  updateCaseWithNewAgentSchemaAction,
} from "../../../../../features/Cases/redux/actions";
import {
  clearMessages,
  setCaseEntityMode,
  setCaseMode,
  setCaseValue,
} from "../../../../../features/Cases/redux/slice";
import { CasesValue } from "../../../../api/instances/casesApi/types";
import { ServiceHandler } from "./storageHandlers";

export const CasesService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      const updatedValue: CasesValue = {
        ...INITIAL_CASE_INFO,
        case_object: {
          ...INITIAL_CASE_INFO.case_object,
          case_info: {
            ...INITIAL_CASE_INFO.case_object.case_info,
            name: normalized.friendly_name,
          },
        },
      };

      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: updatedValue,
          service: meta.arg.service,
        }),
      );
      listenerApi.dispatch(clearMessages());
      listenerApi.dispatch(setCaseValue(updatedValue));
    } catch (e) {
      console.error("Ошибка при создании диалога", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const caseValue = value as CasesValue;

    if (
      caseValue?.case_object?.case_transform_method?.output_attributes == null
    ) {
      listenerApi.dispatch(addNewOutputAttributesFieldAction(caseValue));
      listenerApi.dispatch(setCaseMode("create"));
      listenerApi.dispatch(setCaseEntityMode("case"));
      return;
    }

    if (caseValue && !caseValue?.agent_harness) {
      const updatedValue: CasesValue = {
        ...caseValue,
        agent_harness: INITIAL_CASE_AGENT_HARNESS,
      };
      listenerApi.dispatch(
        editStorageObject({
          id,
          name: caseValue.case_object.case_info.name,
          value: updatedValue,
          service: "cases",
        }),
      );
      listenerApi.dispatch(setCaseEntityMode("case"));
      listenerApi.dispatch(setCaseValue(updatedValue));
      listenerApi.dispatch(setCaseMode("create"));
      return;
    }
    if (!caseValue || !caseValue?.metadata?.has_new_agent_schema) {
      listenerApi.dispatch(
        updateCaseWithNewAgentSchemaAction({ value: caseValue, id }),
      );
      listenerApi.dispatch(setCaseEntityMode("case"));
      listenerApi.dispatch(setCaseMode("create"));
      return;
    }
    listenerApi.dispatch(setCaseEntityMode("case"));
    listenerApi.dispatch(setCaseValue(caseValue));
    listenerApi.dispatch(setCaseMode("create"));
    try {
      listenerApi.dispatch(clearMessages());
      if (!caseValue.metadata || caseValue.metadata.isLegacyObject) {
        const updatedValue: CasesValue = {
          ...INITIAL_CASE_INFO,
          case_object: {
            ...INITIAL_CASE_INFO.case_object,
            case_info: { ...caseValue.case_object.case_info },
          },
          metadata: {
            ...INITIAL_CASE_INFO.metadata,
            isLegacyObject: false,
          },
        };
        listenerApi.dispatch(setCaseValue(updatedValue));
        listenerApi.dispatch(
          editStorageObject({
            id,
            name: caseValue.case_object.case_info.name,
            value: updatedValue,
            service: "cases",
          }),
        );
      }
    } catch {
      console.log("Нет объекта с таким ref");
    }
  },
};
